enum Module {
  // Moudules name
  name = "exposedModules",
  desc = "exposedModules/",
}

enum Mutations {
  "SetExposed" = "setExposed",
}

enum Actions {
  "LoadExposed" = "loadExposed",
  "HandMyEventVoteNone" = "HandMyEventVoteNone",
  "HandMyEventVote" = "HandMyEventVote",
  "HandMyMultiEventVote" = "HandMyMultiEventVote",
}

enum Getters {
  "EventStatuses" = "EventStatuses",
  "TheParticipantEvent" = "theParticipantEvent",
  "EventSchedularCountWithMyResponse" = "EventSchedularCountWithMyResponse",
  "EventResponse" = "eventResponse",
  "InvitMember" = "invitMember",
  "EventPartRespStatus" = "eventPartRespStatus",
  "MyParticipationEventsResponses" = "myParticipationEventsResponses",
}

export { Module, Actions, Mutations, Getters };
